var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconDebitCardFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.717 4C1.22 4 0 5.192 0 6.656v11.688C0 19.808 1.219 21 2.717 21h19.566C23.78 21 25 19.808 25 18.344V6.656C25 5.192 23.781 4 22.283 4H2.717zm0 7.969h8.696v1.062H2.717V11.97zm-1.63-4.25h22.826v2.656H1.087V7.719z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconDebitCardFilled;